export default __webpack_public_path__ + "9c7bd947c68b8c62b15567325f1e8e94.svg";